// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.brew_sensory_session_status */
var BrewSensorySessionStatus;
(function (BrewSensorySessionStatus) {
    BrewSensorySessionStatus["draft"] = "draft";
    BrewSensorySessionStatus["active"] = "active";
    BrewSensorySessionStatus["closed"] = "closed";
})(BrewSensorySessionStatus || (BrewSensorySessionStatus = {}));
;
export default BrewSensorySessionStatus;
/** Zod schema for brew_sensory_session_status */
export const brewSensorySessionStatus = z.nativeEnum(BrewSensorySessionStatus);
//# sourceMappingURL=BrewSensorySessionStatus.js.map